import { Auth } from 'aws-amplify';
import awsConfig from 'common/configs/awsConfig';
import DeleteAccount from 'features/edit-profile/components/DeleteAccount';

const AuthService = {

  login: async (email, password, rememberMe) => {
    if (rememberMe) {
      Auth.configure({ ...awsConfig.Auth, storage: localStorage })
    } else {
      Auth.configure({ ...awsConfig.Auth, storage: sessionStorage });
    }

    return await Auth.signIn(email, password);
  },

  getCurrentSession: async () => {
    if (sessionStorage.length) {
      Auth.configure({...awsConfig.Auth, storage: sessionStorage})
    } else {
      Auth.configure({...awsConfig.Auth, storage: localStorage})
    }
    return await Auth.currentSession();
  },

  signup: async (email, password) => {
    return await Auth.signUp({username: email, password, attributes: { email, 'custom:level': '2', 'custom:scope': '', 'custom:env': process.env.REACT_APP_ENVIRONMENT}});
  },

  confirmSignup: async (email, confirmationCode) => {
    return await Auth.confirmSignUp(email, confirmationCode);
  },

  resetPassword: async (username) => {
    return await Auth.forgotPassword(username);    
  },
  confirmResetPassword: async (username, code, newPassword) => {
    return await Auth.forgotPasswordSubmit(username, code, newPassword);
  },

  changePassword: async (username, oldPassword, newPassword) => {
    return await Auth.changePassword(username, oldPassword, newPassword);
  },
  getCurrentAuthenticatedUser: async () => {
    return await Auth.currentAuthenticatedUser();
  },
  logout: async () => {
    return await Auth.signOut();
  },

  deleteAccount: async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      await Auth.deleteUser(user);
      console.log('User deleted successfully');
    } catch (error) {
      console.log('Error deleting user: ', error);
      throw error;
    }
  },

  checkUserStatus: async () => {
    return await Auth.currentAuthenticatedUser();
  },

  resendConfirmationCode: async (email) => {
    try {
      return await Auth.resendSignUp(email);
    } catch (error) {
      console.log('Error resending confirmation code: ', error);
      throw error;
    }
  },

  verifyPassword: async (password) => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      await Auth.signIn(user.username, password);
      return { success: true };
    } catch (error) {
      console.log('Error verifying password: ', error);
      return { success: false };
    }
  },

};

export default AuthService;